<div class="banner-container-placeholder">
  <!-- <div class="banner-summary">
    <div class="container">
      <div *ngFor="let i of getNumber">
        <div class="browse-capsule-placeholder">
          <div class="circle"></div>
          <div class="capsule"></div>
        </div>
      </div>
    </div>
  </div> -->
</div>

<div class="container">
  <div class="row">
    <div class="category-container-placeholder col-lg-3 col-md-3" *ngIf="!isMobile">
      <div *ngFor="let i of [].constructor(5)">
        <div class="browse-capsule-placeholder">
          <div class="circle"></div>
          <div class="capsule"></div>
        </div>
      </div>
    </div>
    <div class="widget-container-placeholder col-lg-9 col-md-9">
      <div *ngFor="let i of getWidgets" class="pseudo-widget">
        <div class="widget-placeholder">
          <div class="widget-banner"></div>
          <div *ngFor="let i of [].constructor(3)">
            <div class="widget-line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>